import { Http } from '@/model/Http.js'

export default class kfc extends Http {

  //获取用户已授权公众号数据
  getAuthPublicList(data){
    const url = 'api/open/platform/get'
    return this.postAjaxByKfc(url, {
       ...data
    })
  }

  //获取平台绑定密码
  getSecret(data){
    const url = 'api/public/get-secret'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }


  //公众号授权
  getAuth(data){
    const url = 'third/go/auth-pub'
    return this.postAjaxByKfc(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/kfc/kfc.js